import { Exception, toErrorEvent, fromObject, toObject, fromErrorEvent } from "../error.ts";
//@ts-ignore
globalThis["Exception"] = Exception;
Error.toObject = toObject;
Error.fromObject = fromObject;
Error.toErrorEvent = toErrorEvent;
Error.fromErrorEvent = fromErrorEvent;
Error.prototype.toJSON = function toJSON() {
    return toObject(this);
};
//# sourceMappingURL=error.js.map